var constants = require('../constants');
var initialState = require('../../initialState');

var surveyStateHistoryReducer = function(state, action) {
  var newstate = Object.assign({},state);
  switch (action.type) {
	  case constants.CACHE_SURVEY_STATE:
	  	newstate.data = newstate.data.concat(action.surveySate);
	  	return newstate;
	  case constants.GO_PREVIOUS_SURVEY_STATE:
	  	newstate.data = newstate.data.slice(0, newstate.data.length - 1);
	  	return newstate;
	  default: return state || initialState.surveyStateHistory;
  }
}

module.exports = surveyStateHistoryReducer;



// WEBPACK FOOTER //
// ./src/common/modules/surveyStateHistory/reducers/surveyStateHistory.js